import React from "react";
import {
  Slide,
  TextField,
  Grid,
  FormControl,
  InputLabel,
  FormHelperText,
  Input,
  FormLabel,
  FormGroup,
  FormControlLabel,
  Checkbox,
  Button,
  Paper
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

import { useHistory } from "react-router-dom";
import { connect, useSelector } from "react-redux";
import { ApplicationState } from "../store";
import * as APIStore from "../store/APIStore";
import { useState, useEffect } from "react";
import Chip from "@material-ui/core/Chip";
import AssignmentIndIcon from "@material-ui/icons/AssignmentInd";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import CancelIcon from "@material-ui/icons/Cancel";
import RequestAccessToken from '../util/authService';
import './style.css';


type AccountProfileByRefMDProps = APIStore.RefMdProfile &
  APIStore.HNIContextState &
  typeof APIStore.actionCreators;


const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiTextField-root": {
      margin: theme.spacing(1),
      width: "25ch",
    },
  },
  chip: {
    margin: theme.spacing(0.5),
  },
}));

const Account = (props: AccountProfileByRefMDProps) => {
  const classes = useStyles();
  let [profileState, setProfileState] = useState<APIStore.RefMdProfile>(
    {} as APIStore.RefMdProfile
  );

  let [loadState, setLoadState] = useState({ status: true });
  let [tokenState, setTokenState] = useState<APIStore.TokenType>();

  let {
    requestVitalsMdProfile,
    requestSystemSpecialties,
    userRefMdProfile,
    submitRefMD,
    requestCurrentUserCareCoordinatorProfile,
    userPracticeCoordinatorProfile
  } = props;

  let SystemSpecialties: APIStore.SpecialtyState = props.SystemSpecialties;
  let { isLoading, VitalsReferenceSpecialties }: APIStore.SpecialtyState = SystemSpecialties;
  let specialtiesLoaded = SystemSpecialties.isLoaded;

  let { specialties: refSpecialties } = VitalsReferenceSpecialties;

  let [specialties, setSpecialties] = useState(
    [] as Array<APIStore.VitalsReferenceSpecialty>
  );

  let { refmdProfile, notFound, isLoaded, isErrored }: APIStore.RefMDProfileState = userRefMdProfile;

  useEffect(() => {
    if (isLoaded && !isErrored && !notFound) {
      setProfileState(refmdProfile);
      setLoadState({ status: true });
      let specialtiesAsList = [...refmdProfile.specialties];
      setSpecialties(specialtiesAsList);
    }
  }, [refmdProfile]);

  let tokenStatePr = RequestAccessToken()
    .then((token) => {
      if (token && !tokenState) {
        setTokenState(token);
      }
    });

  useEffect(() => {
    if (!isLoaded && !isErrored && !notFound && tokenState && tokenState.accessToken) {
      requestVitalsMdProfile(tokenState.accessToken);
    }
  }, [tokenState]);

  useEffect(() => {
    if (notFound && tokenState && tokenState.accessToken) {
      requestCurrentUserCareCoordinatorProfile(tokenState.accessToken);
    }
  }, [tokenState, notFound]);

  useEffect(() => {
    if (!isLoading && !specialtiesLoaded && tokenState?.accessToken) {
      requestSystemSpecialties(tokenState.accessToken);
    }
  }, [tokenState]);

  const handleChange = (event: any) => {
    let selectedItem = event.target.value;
    setSpecialties(selectedItem);
    setProfileState({
      ...profileState,
      specialties: selectedItem
    });
  };

  const handleAlertChange = (event: any) => {
    if (event.target.name === "admitalerts") {
      setProfileState({
        ...profileState,
        notifyAdmits: !profileState.notifyAdmits,
      });
    }

    if (event.target.name === "dischargealerts") {
      setProfileState({
        ...profileState,
        notifyDischarges: !profileState.notifyDischarges,
      });
    }
  };

  const handleSpecialtyDelete = (specialtyId: any) => {
    let filtered = specialties.filter((val) => val.specialtyId !== specialtyId);
    setSpecialties(filtered);
    setProfileState({
      ...profileState,
      specialties: filtered
    });
  };

  const submitUpdate = () => {

    submitRefMD(profileState, tokenState?.accessToken);
  };

  const updateFirstName = (e: any) => {
    let newProfile = {
      ...refmdProfile,
      firstName: e.target.value,
    };
    setProfileState(newProfile);
  };

  const updateLastName = (e: any) => {
    let newProfile = {
      ...refmdProfile,
      lastName: e.target.value,
    };
    setProfileState(newProfile);
  };

  const updatePhoneNumber = (e: any) => {
    let newProfile = {
      ...refmdProfile,
      phone: e.target.value,
    };
    setProfileState(newProfile);
  };

  const history = useHistory();

  if (userPracticeCoordinatorProfile && userPracticeCoordinatorProfile.isLoaded) {
    history.push(`/account-care-coord`);
    return (
      <React.Fragment>
        <p>No RefMD profile found</p>
      </React.Fragment>
    );
  }

  if (notFound) {
    return (
      <React.Fragment>
        <p>No profile found</p>
      </React.Fragment>
    );
  }


  if (
    !loadState ||
    !loadState.status ||
    !refSpecialties ||
    !refSpecialties.length ||
    !profileState ||
    !profileState.referringMDId
  ) {
    return (
      <React.Fragment>
        <p>Loading</p>
      </React.Fragment>
    );
  }

  const ITEM_HEIGHT = 48;
  const ITEM_PADDING_TOP = 8;
  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
        width: 250,
      },
    },
  };

  let icon = <AssignmentIndIcon />;



  return (
    <Slide in timeout={1000} direction="left">
      <div className="maincontent" style={{ padding: 24 }}>
        <Grid container spacing={3}>
          <Grid item xs={6}>
            <FormControl>
              <InputLabel htmlFor="name-input">First Name</InputLabel>
              <Input
                id="name-input"
                value={profileState.firstName}
                onChange={updateFirstName}
                aria-describedby="my-helper-text"
              />
            </FormControl>
          </Grid>
          <Grid item xs={6}>
            <FormControl>
              <InputLabel htmlFor="my-input">Last Name</InputLabel>
              <Input
                id="my-input"
                value={profileState.lastName}
                aria-describedby="my-helper-text"
                onChange={updateLastName}
              />
            </FormControl>
          </Grid>
          <Grid item xs={6}>
            <FormControl>
              <InputLabel htmlFor="email">Email Address</InputLabel>
              <Input
                id="email"
                disabled={true}
                value={profileState.email}
                aria-describedby="email-helper-text"
              />
              <FormHelperText id="email-helper-text">
                Email used by VitalsMD&trade;
              </FormHelperText>
            </FormControl>
          </Grid>
          <Grid item xs={6}>
            <FormControl>
              <InputLabel htmlFor="phone-number">Phone Number</InputLabel>
              <Input
                onChange={updatePhoneNumber}
                id="phone-number"
                value={profileState.phone}
                aria-describedby="Phone number"
              />
            </FormControl>
          </Grid>
          <Grid item xs={6}>
            <FormControl>
              <InputLabel htmlFor="npi-input">10 digit NPI</InputLabel>
              <Input
                disabled={true}
                id="npi-input"
                value={profileState.npi}
                aria-describedby="10 digit NPI"
              />
            </FormControl>
          </Grid>
          <Grid item xs={6}>
            <FormControl>
              <InputLabel id="demo-mutiple-chip-label">Specialty</InputLabel>
              <Select
                labelId="demo-mutiple-chip-label"
                id="demo-mutiple-chip"
                multiple
                value={specialties}
                onChange={handleChange}
                input={<Input id="select-multiple-chip" />}
                renderValue={(selected) => (
                  <div className={classes.chip}>
                    {selected.map((val) => {
                      return (
                        <Chip
                          label={val.description}
                          icon={icon}
                          className={classes.chip}
                          deleteIcon={
                            <CancelIcon
                              onMouseDown={(event) => event.stopPropagation()}
                            />
                          }
                          onDelete={(event) =>
                            handleSpecialtyDelete(val.specialtyId)
                          }
                        />
                      );
                    })}
                  </div>
                )}
                MenuProps={MenuProps}
              >
                {refSpecialties.map((refSpecialty) => (
                  <MenuItem key={refSpecialty.specialtyId} value={refSpecialty}>
                    {refSpecialty.description}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>

          <Grid item xs={12}>
            <FormControl required component="fieldset">
              <FormLabel component="legend">Send me alerts on:</FormLabel>
              <FormGroup>
                <FormControlLabel
                  control={
                    <Checkbox
                      key={"check1"}
                      checked={profileState.notifyAdmits}
                      onChange={handleAlertChange}
                      name="admitalerts"
                    />
                  }
                  label="Admits"
                />
                <FormControlLabel
                  control={
                    <Checkbox
                      key={"check2"}
                      checked={profileState.notifyDischarges}
                      onChange={handleAlertChange}
                      name="dischargealerts"
                    />
                  }
                  label="Discharges"
                />
              </FormGroup>
            </FormControl>
          </Grid>
          <Grid item xs={12}>
            <Grid container alignContent='flex-start' alignItems='flex-start' justifyContent='flex-start'>
              <Button variant="contained" className="btn-primary" size="large" color="primary" disableElevation title="Save" onClick={submitUpdate}>
                Save
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </div>
    </Slide>
  );
};

export default connect(
  (state: ApplicationState) => state.vitalsContext,
  APIStore.actionCreators
)(Account as any);
